//Action Types
export const SUBMIT_CMS_REGISTER_COMPLAINT_ACTION_REQUESTED =
  "SUBMIT_CMS_REGISTER_COMPLAINT_ACTION_REQUESTED";
export const SUBMIT_CMS_REGISTER_COMPLAINT_ACTION_DISPATCHER =
  "SUBMIT_CMS_REGISTER_COMPLAINT_ACTION_DISPATCHER";
export const SUBMIT_CMS_REGISTER_COMPLAINT_ERROR_DISPATCHER =
  "SUBMIT_CMS_REGISTER_COMPLAINT_ERROR_DISPATCHER";
export const SUBMIT_EMPTY_CMS_REGISTER_COMPLAINT_STATE_ACTION =
  "SUBMIT_EMPTY_CMS_REGISTER_COMPLAINT_STATE_ACTION";
export const CMS_REGISTER_COMPLAINT_LOADING = "CMS_REGISTER_COMPLAINT_LOADING";

//Action Creator
export const submitCMSRegisterComplaintAction = (data) => ({
  type: SUBMIT_CMS_REGISTER_COMPLAINT_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitCMSRegisterComplaintActionDispatcher = (data) => ({
  type: SUBMIT_CMS_REGISTER_COMPLAINT_ACTION_DISPATCHER,
  payload: data,
});

//Error Dispatcher
export const submitCMSRegisterComplaintErrorDispatcher = (data) => ({
  type: SUBMIT_CMS_REGISTER_COMPLAINT_ERROR_DISPATCHER,
  payload: data,
});

//Loading Action
export const cmsRegisterComplaintLoading = (loading) => ({
  type: CMS_REGISTER_COMPLAINT_LOADING,
  payload: loading,
});

export const submitEmptyCMSRegisterComplaintStateAction = () => ({
  type: SUBMIT_EMPTY_CMS_REGISTER_COMPLAINT_STATE_ACTION,
});
